import {
  fontSize12,
  fontSize16,
  gridGutter,
  gridGutterHalf,
  gridGutter1q3,
  gridGutter1q1dot5,
  gridGutter1q4
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../../../../js/shared/new-theme";

export const loadingStyle = `
	display: flex;
	justify-content: center;
	padding: 64px 0;
	width: 100%;
`;

export const averageMilesStyle = `
  .info { 
    display: flex;

    &-text {
      margin: 0 0 ${gridGutter1q3}px 0;
      font-size: ${fontSize12};
      font-weight: 600;
      span {
        color: ${theme.palette.gray[800].value};
        padding-right: ${gridGutter1q3}px;
      }
    }

    &-loading {
      display: inline-block;
    }
  }

  .average-separator {
    margin: ${gridGutter1q1dot5}px 0 ${gridGutter}px 0;
  }
`;

export const offerMilesStyle = `
  padding: ${gridGutter1q4}px ${gridGutter}px;
  h6 {
    margin-bottom: ${gridGutter}px;
  }

	a {
		color: ${theme.palette.gray[800].value};
    cursor: pointer;
    text-decoration: underline;
	}

  .title {
    font-size: ${fontSize16};
    font-weight: bold;
    margin-bottom: ${gridGutter}px;
  }

  .quant-offer-miles {
    margin-bottom: ${gridGutter}px;
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .average-offer-miles {
    &--wrapper {
      margin: 0 0 ${gridGutterHalf}px 0;
      display: block;
    }
  }

  .price-offer-miles {
    // margin-bottom: ${gridGutter}px;
    padding-bottom: 16px;

    &--wrapper {
      margin: 0 0 ${gridGutter1q3}px 0;
      display: block;
    }
    &--text {
      font-size: ${fontSize12};
      font-weight: 500;
      span {
        color: ${theme.palette.gray[800].value};
      }
    }
    &--loading {
      display: inline-block;
    }
  }

  .miles-reduction-tickets {
    margin: ${gridGutter}px 0;
  }  

  .show-advanced-settings {
    &--label {
      font-size: ${fontSize12};
      font-weight: normal;
    }
  }

  .check-smiles-diamond {
    &--wrapper {
      margin: ${gridGutter}px 0;
    }
    &--separator {
      margin-top: -12px;
    }
    &--label {
      font-size: ${fontSize12};
      font-weight: normal;
      strong {
        color: ${theme.palette.gray[600].value};
      }
    }
  }

  .fidelity-and-bank {
    background: ${theme.palette.common.white};
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      color: ${theme.palette.gray[600].value};
    }
    margin: 0 -30px;
    padding: 15px 30px;
    border-top: 1px solid ${theme.palette.gray[400].value};
    border-bottom: 1px solid ${theme.palette.gray[400].value};
  }

  .acceptance-terms-mobile {
    margin-bottom: 50px;
  }

  .dynamic-range {
    background: ${theme.palette.common.white};
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      color: ${theme.palette.gray[600].value};
    }
    margin: 0 -30px -10px;
    padding: 15px 30px;
    border-top: 0;
    border-bottom: ${gridGutter1q4}px solid ${theme.palette.gray[400].value};
  }

  .hidden-component {
    width: 0;
    height: 0;
    overflow: auto;
    position: absolute;
    bottom: 0;
  }
`;
